import { createContext, useContext, useMemo } from 'react';
import type { ReactNode } from 'react';

type ProfileDropdownControlContextType = {
  closeMenu: () => void;
};

export const ProfileDropdownControlContext = createContext<ProfileDropdownControlContextType>({
  closeMenu: () => {
    throw new Error('ProfileDropdownControlContext used before being provided');
  },
});

type ProfileDropdownControlProviderProps = {
  closeMenu: () => void;
  children: ReactNode;
};

export function ProfileDropdownControlProvider({
  closeMenu,
  children,
}: ProfileDropdownControlProviderProps) {
  const value = useMemo(() => ({ closeMenu }), [closeMenu]);

  return (
    <ProfileDropdownControlContext.Provider value={value}>
      {children}
    </ProfileDropdownControlContext.Provider>
  );
}

export function useProfileDropdownControl() {
  return useContext(ProfileDropdownControlContext);
}
